<template>
    <div class="simple-form">
        <div class="form-group center">
            <div class="form-label">
                <label>机构名称</label>
            </div>
            <div class="form-value width-1-5x">
                <span>{{shopDevice.retailerComName}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>资产描述全称</label>
            </div>
            <div class="form-value width-1-5x">
                <span>{{shopDevice.title}}</span>
            </div>
        </div>

        <div class="form-group center">
            <div class="form-label">
                <label>品牌</label>
            </div>
            <div class="form-value width-1-5x">
                <span>{{shopDevice.brandName}}</span>
            </div>
        </div>

        <div class="form-group center">
            <div class="form-label">
                <label>分类</label>
            </div>
            <div class="form-value width-1-5x">
                <span>{{shopDevice.catName}}</span>
            </div>
        </div>

        <div class="form-group center">
            <div class="form-label">
                <label>分类分组</label>
            </div>
            <div class="form-value width-1-5x">
                <span>{{getDevcGroupNameByCatId(shopDevice.catId)}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>数量</label>
            </div>
            <div class="form-value width-1-5x">
                <span>{{shopDevice.quantity}}</span>
            </div>
        </div>

        <div class="form-group center">
            <div class="form-label">
                <label>单位</label>
            </div>
            <div class="form-value width-1-5x">
                <span>{{shopDevice.theUnit}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { openBigImgDlg } from '../comn/dialog'
    import { getDevcGroupNameByCatId } from '../index'

    import userApi from '../../api/user'

    export default {
        name: 'swb-shop-device-grabIssue-detail',
        desc: '机构资产详情',
        props: ['shopDevice', 'activeName'],
        data: function () {
            return {}
        },
        created: function () {
        },
        methods: {
            getDevcGroupNameByCatId(catId){
                return getDevcGroupNameByCatId(catId);
            },
            viewImage: function (fileBrowseUrl) {
                openBigImgDlg(fileBrowseUrl);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceGrabIssueDetail.vue